import { render } from "./PlatformDetailsCustom.vue?vue&type=template&id=9cd352c0"
import script from "./PlatformDetailsCustom.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformDetailsCustom.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PlatformDetailsCustom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9cd352c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9cd352c0', __exports__)) {
    api.reload('9cd352c0', __exports__)
  }
  
  module.hot.accept("./PlatformDetailsCustom.vue?vue&type=template&id=9cd352c0", () => {
    api.rerender('9cd352c0', render)
  })

}


export default __exports__